class CompanyModel {
	id;

	title;

	label;

	description;

	link;

	image;

	constructor({
		_id = '', title = '', label = '',
		description = '', link = '', image = '',
	}) {
		this.id = _id;
		this.title = title;
		this.label = label;
		this.description = description;
		this.link = link;
		this.image = image;
	}
}

export default CompanyModel;
